import * as React from 'react';
import Box from '@mui/material/Box';
import Paper from '@mui/material/Paper';
import Grid from '@mui/material/Grid';
import { Typography } from '@material-ui/core';
import Card from '@mui/material/Card';
import CardContent from '@mui/material/CardContent';
import InvestmentIcon01 from '../../../../utils/assests/investment-icon-01.png';
import InvestmentIcon02 from '../../../../utils/assests/investment-icon-02.png';
import InvestmentIcon03 from '../../../../utils/assests/investment-icon-03.png';
import InvestmentIcon04 from '../../../../utils/assests/investment-icon-04.png';
import InvestmentIcon05 from '../../../../utils/assests/investment-icon-05.png';
export default function InvestmentForm(props: any) {
  const { currentInvestment, handleKnowMore } = props;

  const handleRoi = (value: any) => {
    if(value <= 12 && value > 0){
      return `${value}% p.a.`
    }else{
      if(13 <= 36){
        return `${value}% S.I.`
      }else 
      return `${value}%`
    }
  }
  
  return (
    <>
      {currentInvestment && currentInvestment?.length > 0
        ? currentInvestment.map((item: any) => {
            return (
              <>
                <Grid
                  container
                  spacing={3}
                  marginBottom={2}
                  justifyContent='center'
                  className='innerCardStyle TwoRows'
                >
                  <Grid item xs={5}>
                    <Paper>
                      <img src={InvestmentIcon01} alt='' width='40' />
                      <Typography component='span'>invested amount</Typography>
                      <Typography>{item.invested_amount}</Typography>
                    </Paper>
                  </Grid>
                  <Grid item xs={5}>
                    <Paper>
                      <img src={InvestmentIcon02} alt='' width='40' />
                      <Typography component='span'>R0I</Typography>
                      <Typography>{handleRoi(item.investment_roi)}</Typography>
                    </Paper>
                  </Grid>

                  <Grid item xs={5}>
                    <Paper>
                      <img src={InvestmentIcon03} alt='' width='40' />
                      <Typography component='span'>Lockin tenure</Typography>
                      <Typography>{item.lockin_tenure}</Typography>
                    </Paper>
                  </Grid>

                  <Grid item xs={5}>
                    <Paper>
                      <img src={InvestmentIcon04} alt='' width='40' />
                      <Typography component='span'>transation ID</Typography>
                      <Typography>{item.transaction_id}</Typography>
                    </Paper>
                  </Grid>
                  <Grid item xs={5}>
                    <Paper>
                      <img src={InvestmentIcon05} alt='' width='40' />
                      <Typography component='span'>transation Date</Typography>
                      <Typography>{item.transaction_date}</Typography>
                    </Paper>
                  </Grid>
                  <Grid onClick={() => handleKnowMore('current')} item xs={5}>
                    <Paper className='knowMore'>
                      <Typography>know more</Typography>
                    </Paper>
                  </Grid>
                </Grid>
              </>
            );
          })
        : 'No current investments found'}
    </>
  );
}
